import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'twoFactor'

const SETUP_TWO_FACTOR = createRequestTypes(prefix, 'SETUP_TWO_FACTOR')
const ENABLE_TWO_FACTOR = createRequestTypes(prefix, 'ENABLE_TWO_FACTOR')
const VERIFY_TWO_FACTOR = createRequestTypes(prefix, 'VERIFY_TWO_FACTOR')
const DISABLE_TWO_FACTOR = createRequestTypes(prefix, 'DISABLE_TWO_FACTOR')

export const [SETUP_TWO_FACTOR_REQUEST, SETUP_TWO_FACTOR_SUCCESS, SETUP_TWO_FACTOR_FAILURE] =
  SETUP_TWO_FACTOR
export const [ENABLE_TWO_FACTOR_REQUEST, ENABLE_TWO_FACTOR_SUCCESS, ENABLE_TWO_FACTOR_FAILURE] =
  ENABLE_TWO_FACTOR
export const [VERIFY_TWO_FACTOR_REQUEST, VERIFY_TWO_FACTOR_SUCCESS, VERIFY_TWO_FACTOR_FAILURE] =
  VERIFY_TWO_FACTOR
export const [DISABLE_TWO_FACTOR_REQUEST, DISABLE_TWO_FACTOR_SUCCESS, DISABLE_TWO_FACTOR_FAILURE] =
  DISABLE_TWO_FACTOR

export const setup2FA = createAction(() => ({
  type: SETUP_TWO_FACTOR,
  promise: (api: IApi) => api.twoFactor.setup(),
}))

export const enable2FA = createAction(
  (params: { secret: string; verificationCode: string; backupCodes: string[] }) => ({
    type: ENABLE_TWO_FACTOR,
    promise: (api: IApi) => api.twoFactor.enable(params),
    params,
  }),
)

export const verify2FA = createAction(
  (params: { tempUserId: string; code: string; isBackupCode?: boolean }) => ({
    type: VERIFY_TWO_FACTOR,
    promise: (api: IApi) => api.twoFactor.verify(params),
    params,
  }),
)

export const disable2FA = createAction((params: { password: string }) => ({
  type: DISABLE_TWO_FACTOR,
  promise: (api: IApi) => api.twoFactor.disable(params),
  params,
}))

// Clear setup data action
export const CLEAR_SETUP_DATA = `${prefix}/CLEAR_SETUP_DATA`

export const clearSetupData = () => ({
  type: CLEAR_SETUP_DATA,
})
